module.exports = __webpack_public_path__ + "static/media/phonecoverpage4.117de11d.png";